export const ORDER_HISTORY = [
  {
    id: 1,
    purchase_date: '2021/06/16',
    items: [
      {
        id: 1,
        image: 'https://via.placeholder.com/200',
        product_name: 'のむシリカで作ったお肌潤う化粧水',
        product_type: '化粧水',
        quantity: 2,
        price: 4600,
      },
      {
        id: 2,
        image: 'https://via.placeholder.com/200',
        product_name: 'のむシリカで作ったお肌潤う化粧水',
        product_type: '化粧水',
        quantity: 2,
        price: 4600,
      },
    ],
    total: 8200,
    subtotal: 8200,
    shipping_fee: 400,
  },
  {
    id: 2,
    purchase_date: '2021/06/15',
    items: [
      {
        id: 3,
        image: 'https://via.placeholder.com/200',
        product_name: 'のむシリカで作ったお肌潤う化粧水',
        product_type: '化粧水',
        quantity: 2,
        price: 4600,
      },
      {
        id: 4,
        image: 'https://via.placeholder.com/200',
        product_name: 'のむシリカで作ったお肌潤う化粧水',
        product_type: '化粧水',
        quantity: 2,
        price: 4600,
      },
    ],
    total: 8200,
    subtotal: 8200,
    shipping_fee: 400,
  },
]
